import { render, staticRenderFns } from "./redefinir-senha.vue?vue&type=template&id=12fe8d33&scoped=true&"
import script from "./redefinir-senha.vue?vue&type=script&lang=js&"
export * from "./redefinir-senha.vue?vue&type=script&lang=js&"
import style0 from "./redefinir-senha.vue?vue&type=style&index=0&id=12fe8d33&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fe8d33",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCol,VSheet})
